import { ChangeDetectorRef, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SeConstraintNotifierService } from '@se/constraint';
import { Logger } from '@se/se.ui.html5';
import { Moment } from 'moment';
import { map, takeUntil } from 'rxjs/operators';

import { CpAutocompleteControl } from '../../cp-configuration/view-model';
import { CpModelService } from '../../cp-model.service';

import { AbstractControlComponent } from '../abstract-control';
import { CpDatasourceService } from '../../cp-datasource.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { IDataSource } from '@se/cp.common';

@Component({
    selector: 'cp-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
})
export class CpAutocompleteComponent extends AbstractControlComponent {
    control!: CpAutocompleteControl;
    dataSource$!: Observable<string[]>;
    model: string | null = null;
    required = false;
    placeholder: string | null = null;

    private fullDataSource$ = new BehaviorSubject<IDataSource>([]);

    constructor(
        cdr: ChangeDetectorRef,
        private datasourceService: CpDatasourceService,
        constraintNotifierService: SeConstraintNotifierService,
        logger: Logger,
        private modelService: CpModelService
    ) {
        super(cdr, constraintNotifierService, logger);
    }

    protected init() {
        this.dataBind();
    }

    protected onModelChange(model: Moment) {
        return this.control.onModelChange(this.modelService, model, !this.isDisabled);
    }

    private dataBind() {
        if (!this.control.dataBinding) {
            return;
        }

        this.required = this.control.required;
        this.placeholder = this.control.name;

        this.control
            .getEntityObservable(this.modelService)
            .pipe(takeUntil(this.destroyed$))
            .subscribe(this._entitySubject);

        // Valore attuale
        const initialValue = this.control.getInitialValue(this.modelService);
        this.model = initialValue?.toString() ?? null;

        this.formControl = new FormControl(
            this.model,
            this.makeValidator(this._entitySubject, this.control.dataBinding.propertyName, this.control.required)
        );

        // filtro solo il campo che mi interessa
        this.dataSource$ = this.fullDataSource$.pipe(
            takeUntil(this.destroyed$),
            map((data) => {
                return data.map((s) => s.Description);
            })
        );

        // Carico i dati dalla sorgente
        this.fullDataSource$.next(this.datasourceService.getById(this.control.dataSource) || []);

        this.control
            .getModelObservable(this.modelService)
            .pipe(takeUntil(this.destroyed$))
            .subscribe((model) => {
                this.valueChange(model?.toString() ?? null);
                this.logger?.trace(`Model update ${this.control.name} ${model}`);
            });

        this.form.setControl(this.control.name, this.formControl);
    }

    private valueChange(model: string | null) {
        this.model = model;
        this.formControl?.setValue(model);
    }

    onValueChange(value?: string) {
        if (!value) {
            this.valueChange(null);
        } else {
            this.valueChange(value);
        }
    }
}
